<template>
  <ion-modal
    ref="modal"
    :trigger="trigger"
    :initial-breakpoint="0.25"
    :breakpoints="[0, 0.25, 0.5, 0.75, 1]"
  >
    <ion-content class="ion-padding">
      <ion-list>
        <ion-item-group v-for="category in categories" :key="category.name">
          <template v-if="category.attachments && category.attachments.length">
            <ion-item-divider>
              <ion-label
                ><strong>{{ category.name }}</strong></ion-label
              >
            </ion-item-divider>

            <ion-item
              v-for="attachment in category.attachments"
              :key="attachment.id"
              button
              @click="showAttachment(attachment)"
              lines="full"
            >
              <ion-img
                slot="start"
                :src="getAttachmentIconPath(attachment.extension)"
              ></ion-img>

              <ion-label>
                <h2>{{ attachment.name }}</h2>
              </ion-label>
            </ion-item>
          </template>
        </ion-item-group>
      </ion-list>
    </ion-content>
  </ion-modal>
</template>

<script>
import {
  IonModal,
  IonContent,
  IonItem,
  IonItemGroup,
  IonItemDivider,
  IonList,
  IonImg,
  IonLabel,
} from '@ionic/vue';
import HasAttachmentsMixin from '@/mixins/HasAttachmentsMixin';

export default {
  components: {
    IonModal,
    IonContent,
    IonItem,
    IonItemGroup,
    IonItemDivider,
    IonList,
    IonImg,
    IonLabel,
  },

  mixins: [HasAttachmentsMixin],

  props: {
    trigger: String,
    categories: Array,
  },
};
</script>

<style scoped lang="scss">
ion-img {
  max-width: 32px;
  height: 32px;
  margin: 1rem;
}

ion-item {
  --padding-start: 0;
}

ion-item-divider {
  --color: #000000;
}
</style>
